import { doc, Firestore, setDoc,updateDoc,deleteDoc, deleteField,Timestamp,increment } from 'firebase/firestore'; 
import { FruitPropsType, removeFruitPropsExtraInfo,FruitPropsFirebaseTypeOptions} from 'src/views/harvesting/fruit-profile/model';
import { filterAwayExpiredLocks,removeMylocks} from 'src/views/harvesting/fruit-profile/fruit-profile-single/utils/smart-filtering';
import {getCurrentTime} from 'src/utils';
import moment from 'moment';
// eslint-disable-next-line @typescript-eslint/ban-types


export const fruitProfileWrite = (db:Firestore,name:string, mergeFruits:FruitPropsType,options:FruitPropsFirebaseTypeOptions, removeLock=false) =>{
  const newIslocked = mergeFruits.isLocked&& mergeFruits.isLocked.length>0?[{
    name: name,
    createdAt: getCurrentTime()
  },...removeMylocks(mergeFruits.isLocked,name)]:[{
    name: name,
    createdAt: getCurrentTime()
  }];

  const isRemoveLock = filterAwayExpiredLocks(removeMylocks(mergeFruits.isLocked??[],name));
  // console.log('filterAwayExpiredLocks(options.isLocked??newIslocked),',options.isLocked??newIslocked,filterAwayExpiredLocks(options.isLocked??newIslocked));

  return setDoc(doc(db, 'fishes', mergeFruits.id), {
    ...removeFruitPropsExtraInfo({...mergeFruits,name:mergeFruits.name.toLowerCase().trim()}),
    isLocked:removeLock? isRemoveLock:filterAwayExpiredLocks(newIslocked),
    ...options,
  });
};



export const fruitProfileRemove = (db:Firestore,fruits:any)=>{

  fruits.forEach((fruit:any)=>{
    deleteDoc(doc(db, 'fishes', fruit.id));
  });
};

export const textedCounter = (
  db:Firestore,
  fishId:string,
  fishName:string, 
  uid:string, 
  userName:string,
  groupNum:number,
  teamNum:number,
  method:'increase'|'decrease')=>{
  const isIncrease = method ==='increase';
  const increOrDecre= ()=> isIncrease?increment(1):increment(-1);

  const reportCounterRef = doc(db, 'reportCounter',moment().format('MM-DD-YYYY'));
  const memberCounterRef = doc(db, 'reportCounter',moment().format('MM-DD-YYYY'),'members',uid);

  const groupCounterRef = doc(db, 'reportCounter',moment().format('MM-DD-YYYY'),'groups',groupNum+'');

 

  const updateYouthPromise = setDoc(reportCounterRef,{
    totalCount: increOrDecre(),
    date:Timestamp.fromDate(new Date())
  }, { merge: true });
  
  const updateMemberPromise = setDoc(memberCounterRef,{
    textCount: increOrDecre(),
    fishes:{
      [fishId]: isIncrease?{
        name:fishName,
        createdAt: Timestamp.fromDate(new Date()),
      }:deleteField()
    }
  }, { merge: true });

  const updateGroupPromise = setDoc(groupCounterRef,{
    group:groupNum,
    members:{
      [uid]:{
        name:userName,
        team:teamNum,
        textCount: increOrDecre()
      }
    },
    teamCount:{
      [teamNum]:{
        textCount: increOrDecre()
      }
    },
    textCount: increOrDecre(),
  }, { merge: true });

  return Promise.all([
    updateYouthPromise,
    updateGroupPromise,
    updateMemberPromise,
  ]);

};

export const onSubmitOfflineFishingCount = (
  db:Firestore,
  uid:string, 
  userName:string,
  groupNum:number,
  teamNum:number,
  previousOfflineFishingResult:number,
  newOfflineFishingResult:number,
  
)=>{

  const youthOfflineFishingResultCounterRef = doc(db, 'reportCounter',moment().format('MM-DD-YYYY'));
  const memberOfflineFishingResultCounterRef = doc(db, 'reportCounter',moment().format('MM-DD-YYYY'),'members',uid);
  const groupOfflineFishingResultCounterRef = doc(db, 'reportCounter',moment().format('MM-DD-YYYY'),'groups',groupNum+'');

  const resultDiff = newOfflineFishingResult-previousOfflineFishingResult;
  
  const updateMemberOfflineFishingResultPromise = setDoc(memberOfflineFishingResultCounterRef,{
    offlineFishingCount:increment(resultDiff),
  }, { merge: true });

  const updateYouthOfflineFishingResultPromise = setDoc(youthOfflineFishingResultCounterRef,{
    offlineFishingCount: increment(resultDiff),
    date:Timestamp.fromDate(new Date())
  }, { merge: true });


  const updateGroupOfflineFishingResultPromise = setDoc(groupOfflineFishingResultCounterRef,{
    group:groupNum,
    members:{
      [uid]:{
        name:userName,
        team:teamNum,
        offlineFishingCount: increment(resultDiff),
      }
    },
    teamCount:{
      [teamNum]:{
        offlineFishingCount: increment(resultDiff),
      }
    },
    offlineFishingCount: increment(resultDiff),
  }, { merge: true });

  return Promise.all([
    updateMemberOfflineFishingResultPromise,
    updateYouthOfflineFishingResultPromise,
    updateGroupOfflineFishingResultPromise
  ]);


};


export const fruitProfileFisherman = (db:Firestore,fruits:any)=>{

  const fruitRef = doc(db, 'fishes', fruits.id);
  return updateDoc(fruitRef, {
    fishermans: deleteField(),
    fisherman: deleteField(),
    isLocked: deleteField(),
  });
};


